/* FP-YMM picker: cascading Make/Model/Year from local fp-ymm-data.json.
   Zero third-party calls. Multi-instance; exposes window.FPYMM. */
(function () {
  if (window.FPYMM) return;
  var dataPromise = null, DATA = null;
  var FILTER_KEY = 'filter.p.m.custom.fitment_keys';
  var ENGINE_FILTER_KEY = 'filter.p.m.custom.engine_keys';

  function loadData(src) {
    if (!dataPromise) {
      dataPromise = fetch(src).then(function (r) { return r.json(); }).then(function (d) { DATA = d; return d; });
    }
    return dataPromise;
  }
  function findMake(name) {
    return (DATA.makes || []).filter(function (m) { return m.name === name; })[0] || null;
  }
  function findModel(make, name) {
    return make ? (make.models.filter(function (m) { return m.name === name; })[0] || null) : null;
  }
  function maxYear() { return new Date().getFullYear() + 1; }
  function genForYear(model, year) {
    year = Number(year);
    return model.generations.filter(function (g) {
      return year >= g.from && year <= (g.to === null ? maxYear() : g.to);
    })[0] || null;
  }
  function yearsFor(model) {
    var lo = Math.min.apply(null, model.generations.map(function (g) { return g.from; }));
    var hi = model.generations.some(function (g) { return g.to === null; })
      ? maxYear()
      : Math.max.apply(null, model.generations.map(function (g) { return g.to; }));
    var out = [];
    for (var y = hi; y >= lo; y--) { if (genForYear(model, y)) out.push(y); }
    return out;
  }
  function fill(sel, items, placeholder) {
    sel.innerHTML = '';
    var o0 = document.createElement('option');
    o0.value = ''; o0.textContent = placeholder; sel.appendChild(o0);
    items.forEach(function (it) {
      var o = document.createElement('option');
      o.value = String(it); o.textContent = String(it); sel.appendChild(o);
    });
    sel.disabled = items.length === 0;
  }
  function normMake(raw) {
    if (!raw) return '';
    var up = String(raw).trim().toUpperCase();
    if (DATA.aliases.makes[up]) return DATA.aliases.makes[up];
    return (DATA.makes.filter(function (m) { return m.name.toUpperCase() === up; })[0] || {}).name || '';
  }
  function normModel(raw) {
    if (!raw) return '';
    var up = String(raw).trim().toUpperCase().replace(/\s+/g, ' ');
    var hit = DATA.aliases.modelPrefixes.filter(function (p) { return up.indexOf(p[0]) === 0; })[0];
    return hit ? hit[1] : '';
  }
  function state(root) {
    return {
      make: root.querySelector('[data-fpy-make]'),
      model: root.querySelector('[data-fpy-model]'),
      year: root.querySelector('[data-fpy-year]'),
      engine: root.querySelector('[data-fpy-engine]'),
      gen: root.querySelector('[data-fpy-gen]'),
      go: root.querySelector('[data-fpy-go]')
    };
  }
  function currentTruck(root) {
    var s = state(root);
    if (!s.make.value || !s.model.value || !s.year.value) return null;
    var model = findModel(findMake(s.make.value), s.model.value);
    var gen = model && genForYear(model, s.year.value);
    if (!gen) return null;
    var engine = s.engine && s.engine.value
      ? { parent: s.engine.value, child: null, era: null, label: s.engine.value }
      : null;
    return { make: s.make.value, model: s.model.value, year: Number(s.year.value),
             value: gen.value, label: s.year.value + ' ' + s.make.value + ' ' + s.model.value,
             engine: engine };
  }
  function sync(root) {
    var s = state(root), t = currentTruck(root);
    s.gen.textContent = t ? 'Fits generation: ' + t.value : '';
    s.go.disabled = !t;
  }
  function buildUrl(genValue, engine) {
    /* DATA.facets (from facet_status.json via build_ymm_data.py) gates every
       filter family: an S&D facet that is not registered yet gets silently
       stripped by Shopify and the unfiltered results would lie - so until
       Nicolas's G6 clicks we emit a clean collection URL and the truck chip
       shows the honest "filter is coming online" state instead. */
    var f = (DATA && DATA.facets) || {};
    var qs = [];
    if (f.truck && genValue) {
      /* NEVER combine the two families in one URL: Shopify ANDs across filter
         families, so truck+engine params return only dual-keyed products
         (verified 2026-07-06: 0 results). Truck URL = gen + universal;
         engine-fit parts surface via the Engine facet, PDP badges, and the
         dedicated engine link (buildUrl(null, engine)). */
      qs.push(encodeURIComponent(FILTER_KEY) + '=' + encodeURIComponent(genValue));
      qs.push(encodeURIComponent(FILTER_KEY) + '=' + encodeURIComponent(DATA.universal));
    } else if (f.engine && engine && engine.parent) {
      qs.push(encodeURIComponent(ENGINE_FILTER_KEY) + '=' + encodeURIComponent(engine.parent));
      if (engine.child) {
        qs.push(encodeURIComponent(ENGINE_FILTER_KEY) + '=' + encodeURIComponent(engine.child));
      }
    }
    return '/collections/all' + (qs.length ? '?' + qs.join('&') : '');
  }
  function go(root) {
    var t = currentTruck(root);
    if (!t) return;
    var engine = t.engine || null;
    if (window.FPGarage) {
      window.FPGarage.add(t);
      var active = window.FPGarage.getActive();
      if (active && active.label === t.label) engine = active.engine || null;
    }
    try { sessionStorage.setItem('fp_pending_truck', JSON.stringify({ label: t.label, engine: engine, ts: Date.now() })); } catch (e) {}
    var destination = root.dataset.fpyDestination || 'results';
    if (destination === 'stay') return;
    window.location.href = destination === 'garage' ? '/pages/search-by-truck' : buildUrl(t.value, engine);
  }
  function setTruck(root, raw) {
    if (!root || !DATA) return { ok: false, truck: null, unmatched: ['data'] };
    var s = state(root), unmatched = [];
    var mk = normMake(raw.make); if (!mk && raw.make) unmatched.push('make');
    if (mk) { s.make.value = mk; s.make.dispatchEvent(new Event('change')); }
    var md = normModel(raw.model); if (!md && raw.model) unmatched.push('model');
    if (mk && md) { s.model.value = md; s.model.dispatchEvent(new Event('change')); }
    var yr = String(raw.year || '').trim();
    if (mk && md && yr) {
      s.year.value = yr; s.year.dispatchEvent(new Event('change'));
      if (s.year.value !== yr) unmatched.push('year');
    } else if (yr && (!mk || !md)) { unmatched.push('year'); }
    var t = currentTruck(root);
    /* Grafting + committing is only legit when the request actually RESOLVED
       to this picker truck. If make/model/year missed the vocab (e.g. a Mack
       VIN - Mack has no picker entry), the selects still hold the PREVIOUS
       selection, and grafting the new engine/VIN onto it corrupts that truck
       ("2018 Volvo VNL · MP8 · Mack VIN" frankenstein, Nicolas 2026-07-15).
       Callers own the honest make-only garage add for not-in-vocab trucks. */
    if (unmatched.length) {
      return { ok: false, truck: null, unmatched: unmatched };
    }
    if (t && (raw.engine || raw.vin)) {
      t.engine = raw.engine || null;
      t.vin = raw.vin || null;
      t.source = raw.vin ? 'vin' : 'ymm';
    }
    if (s.engine) {
      s.engine.value = raw.engine && raw.engine.parent || '';
      if (t && raw.engine) t.engine = raw.engine;
    }
    if (t && raw.commit && window.FPGarage) { window.FPGarage.add(t); }
    if (t && raw.focus !== false) { s.go.focus(); }
    return { ok: !!t, truck: t, unmatched: unmatched };
  }
  function clearTruck(root) {
    if (!root || !DATA) return;
    var s = state(root);
    s.make.value = '';
    s.make.dispatchEvent(new Event('change'));
    if (s.engine) s.engine.value = '';
    s.gen.textContent = '';
    s.go.disabled = true;
  }
  function init(root) {
    if (root.dataset.fpyInit) return;
    root.dataset.fpyInit = '1';
    loadData(root.dataset.src).then(function () {
      var s = state(root);
      fill(s.make, DATA.makes.map(function (m) { return m.name; }), 'Select make');
      if (s.engine) {
        var parents = (window.FPGarage && window.FPGarage.engineParents) || [];
        fill(s.engine, parents, 'Any / not sure');
        s.engine.disabled = false;
      }
      s.make.addEventListener('change', function () {
        var mk = findMake(s.make.value);
        if (s.engine) s.engine.value = '';
        fill(s.model, mk ? mk.models.map(function (m) { return m.name; }) : [], 'Select model');
        fill(s.year, [], 'Select year'); sync(root);
      });
      s.model.addEventListener('change', function () {
        var model = findModel(findMake(s.make.value), s.model.value);
        fill(s.year, model ? yearsFor(model) : [], 'Select year'); sync(root);
      });
      s.year.addEventListener('change', function () { sync(root); });
      s.go.addEventListener('click', function () { go(root); });
      if (window.FPGarage) {
        window.FPGarage.mount(root);
        var restoreActive = function () {
          if (!document.documentElement.contains(root)) return;
          var active = window.FPGarage.getActive();
          if (active && active.type !== 'trailer') setTruck(root, Object.assign({ focus: false }, active));
          else clearTruck(root);
        };
        restoreActive();
        document.addEventListener('fp:garage-change', restoreActive);
      }
    });
  }
  window.FPYMM = {
    buildUrl: buildUrl,
    data: function () { return DATA; },
    setTruck: function (raw) {
      var root = document.querySelector('[data-fp-ymmw]');
      return setTruck(root, raw);
    },
    clear: function () { clearTruck(document.querySelector('[data-fp-ymmw]')); }
  };
  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-fp-ymmw]'), init);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
})();
